import React from "react";
import { Fade, Slide } from "react-awesome-reveal";
// import shape1 from "../../images/rsvp/shape.svg";
// import shape2 from "../../images/rsvp/shape2.svg";
// import shape3 from "../../images/rsvp/shape3.svg";
// import shape4 from "../../images/rsvp/shape4.svg";
// import shape5 from "../../images/rsvp/shape5.svg";
// import shape6 from "../../images/rsvp/shape6.svg";
import InviteeLists from "./InviteeLists";

import coupleImg3 from "../../images/couple/left-invitee.svg";
import coupleImg4 from "../../images/couple/right-invitee.svg";

const renderList = (title, content, animate) => {
  return content ? (
    <Fade
      key={title}
      className="animate__animated animate__fadeInLeft"
      delay={animate}
      duration={animate * 5}
      triggerOnce="true"
    >
      <div className="wpo-invitee-section-wrapper">
        <p className="orangeText primaryText">{title}</p>
        <pre className="warm-regards">{content}</pre>
      </div>
    </Fade>
  ) : null;
};

const InviteeSection = (props) => {
  const { haveBackground } = props;

  return (
    <InviteeLists>
      {(lists) => (
        <section
          className={`wpo-contact-section ${props.rClass} section-padding inviteeWrapper section`}
        >
          <div className="container">
            <div className="innerWrapper">
              <Slide direction="up" cascade damping={0.2} triggerOnce>
                {lists.map(({ title, names, order }) =>
                  renderList(title, names, Math.min(200 * (order + 1), 600)),
                )}
              </Slide>
            </div>
          </div>

          <div className="left-shape">
            <Slide direction="left" duration={2000}>
              <img src={coupleImg3} alt="" />
            </Slide>
          </div>
          {haveBackground && (
            <div className="right-shape">
              <img src={coupleImg4} alt="" />
            </div>
          )}
        </section>
      )}
    </InviteeLists>
  );
};

export default InviteeSection;
